module.exports = __webpack_public_path__ + "img/profile-placeholder.cda02092.webp";